const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ProductInBox extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 5,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('product-in-box')) {
  customElements.define('product-in-box', ProductInBox)
}
